import useMicrowaveInfluencerAccountsSelect, {
    MicrowaveInfluencerAccountOption,
} from '../../../useMicrowaveInfluencerAccountsSelect';
import { StylesConfig, ValueType } from 'react-select';
import styles from './MicrowaveInfluencerAccountFilter.module.css';
import { BaseFilterObject } from 'App.types';
import SelectFilter from 'ui-new/Filters/SelectFilter/SelectFilter';
import MicrowaveInfluencerAccountOptionLabel from './components/OptionLabel/MicrowaveInfluencerAccountOptionLabel';

type Props = {
    initialAccountId?: number;
    onChange: (value: ValueType<MicrowaveInfluencerAccountOption, false>) => void;
    onClear: () => void;
    onRemove: () => void;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
} & Pick<BaseFilterObject, 'name' | 'icon'>;

const selectStyles: StylesConfig = {
    option: (base) => ({
        ...base,
        padding: '0.3125rem 0',
        marginTop: '0.3125rem',
    }),
};

const MicrowaveInfluencerAccountFilter = ({
    initialAccountId,
    onRemove,
    onChange,
    onClear,
    name,
    icon,
    isOpen,
    onOpen,
    onClose,
}: Props) => {
    const selectProps = useMicrowaveInfluencerAccountsSelect(initialAccountId);

    const clearState = () => {
        selectProps.onChange?.(null, { action: 'clear' });
    };

    return (
        <SelectFilter
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            name={name}
            icon={icon}
            renderValue={(value, props) => {
                if (!value) {
                    return 'Account: none';
                }
                return (
                    <>
                        <span>{props.name}</span>
                        <span className={styles.countBadge}>{1}</span>
                    </>
                );
            }}
            styles={selectStyles}
            onClear={() => {
                clearState();
                onClear();
            }}
            onRemove={() => {
                clearState();
                onRemove();
            }}
            {...selectProps}
            onChange={(value, action) => {
                selectProps.onChange?.(value, action);
                onChange(value);
            }}
            formatOptionLabel={(option, { context }) => {
                if (context === 'value') {
                    return null;
                }
                return <MicrowaveInfluencerAccountOptionLabel {...option} context={context} />;
            }}
        />
    );
};

export default MicrowaveInfluencerAccountFilter;
